import { GraduationCap, HeartHandshake, BookOpenCheck, Users2, MessageSquareText, FileStack } from "lucide-react";

const SERVICES = [
  { icon: GraduationCap, title: "Bimbingan Haji", desc: "Pembinaan jamaah dalam persiapan dan pelaksanaan ibadah Haji." },
  { icon: BookOpenCheck, title: "Bimbingan Umrah", desc: "Pembekalan tata cara dan persiapan ibadah Umrah." },
  { icon: Users2, title: "Manasik Haji & Umrah", desc: "Pembelajaran teori dan praktik secara menyeluruh." },
  { icon: HeartHandshake, title: "Pendampingan Jamaah", desc: "Pendampingan sebelum, selama, dan setelah perjalanan." },
  { icon: MessageSquareText, title: "Konsultasi", desc: "Konsultasi program Haji dan Umrah bersama tim ahli." },
  { icon: FileStack, title: "Administrasi Digital", desc: "Pengelolaan data, dokumen, jadwal, dan informasi jamaah." },
];

export default function Services() {
  return (
    <section className="bg-[#F5F9F7] py-20" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Layanan Kami</span>
          <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Layanan Bimbingan Terpadu</h2>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <div
              key={s.title}
              data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group rounded-2xl bg-white p-7 shadow-[0_2px_16px_rgba(15,107,79,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(15,107,79,0.12)]"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-[#0F6B4F]/10 to-[#1677B8]/10 text-[#0F6B4F] transition-colors group-hover:from-[#0F6B4F] group-hover:to-[#1677B8] group-hover:text-white">
                <s.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-heading text-lg font-semibold text-[#1F2937]">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#64748B]">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
